import React from "react";

export const TableInputGap: React.FC = () => {
  return (
    <tr>
      <td colSpan={3}>&nbsp;</td>
    </tr>
  );
};
